import { useEffect, useRef, useState } from 'react';
import { apiGetCaptchaeImg, apiH5RebateApply, apiH5SendSmsCode } from '../api';
import { showToast } from '../utils/utils';
import MessageDialog from '../components/messageDialog';
import CaptchaDialog from '../components/captchaDialog';
interface prompt {
  captchaId?: string,
  captchaImg?: string,
  captchaSwitch?: boolean
}
export default function RefundFeePage() {
  const [activatePhone, setactivatePhone] = useState('');
  const [cardNum, setcardNum] = useState('');
  const [captchaCode, setcaptchaCode] = useState('');
  const [smsCode, setSmsCode] = useState('');
  const [smsCountdown, setSmsCountdown] = useState(0);
  const smsTimerRef = useRef<ReturnType<typeof setInterval> | null>(null);
  // 图形验证码弹窗：点击获取验证码后弹出，图形码校验通过才下发短信
  const [captchaDialogShow, setcaptchaDialogShow] = useState(false);
  const [messageDialogShow, setmessageDialogShow] = useState('');
  
  const [promptCode, setpromptCode] = useState<prompt>({});
  
  useEffect(() => {
    getCodeImg()
    return () => {
      if (smsTimerRef.current) clearInterval(smsTimerRef.current);
    }
  }, [])
  async function getCodeImg() {
    const res = await apiGetCaptchaeImg()
    if (res?.data?.code === 200) {
      setpromptCode(res?.data?.data || {})
    }
  }
  // 点击获取验证码：只弹图形验证码弹窗，不直接下发短信
  function handleSendSmsCode() {
    if (!activatePhone || activatePhone.length !== 11) {
      setmessageDialogShow('请输入正确的激活号码')
      return
    }
    setcaptchaCode('')
    getCodeImg()
    setcaptchaDialogShow(true)
  }
  // 弹窗内点确定：带图形验证码调下发接口，校验通过才真正发短信
  async function handleConfirmCaptcha() {
    if (!captchaCode) {
      showToast('请输入图形验证码')
      return
    }
    const res = await apiH5SendSmsCode({ activatePhone, captchaCode, captchaId: promptCode.captchaId })
    if (res?.data?.code === 200) {
      showToast(res?.data?.msg ?? '验证码发送成功')
      setcaptchaDialogShow(false)
      setcaptchaCode('')
      setSmsCountdown(60)
      startSmsCountdown()
    } else {
      // 图形码错误/过期：弹窗保持打开，换一张图并清空输入，便于直接重填
      showToast(res?.data?.msg ?? '验证码发送失败')
      getCodeImg()
      setcaptchaCode('')
    }
  }
  // 关闭图形验证码弹窗：不下发短信、不进入倒计时
  function handleCloseCaptcha() {
    setcaptchaDialogShow(false)
    setcaptchaCode('')
  }

  function startSmsCountdown() {
    if (smsTimerRef.current) clearInterval(smsTimerRef.current)
    smsTimerRef.current = setInterval(() => {
      setSmsCountdown((prev) => {
        if (prev <= 1) {
          if (smsTimerRef.current) clearInterval(smsTimerRef.current)
          return 0
        }
        return prev - 1
      })
    }, 1000)
  }

  async function handleSubmit() {
    // 提交只校验短信验证码，图形验证码已前移到获取验证码弹窗
    const res = await apiH5RebateApply({activatePhone,cardNum,smsCode})
    if(res?.data?.code === 200){
      showToast(res?.data?.msg ??'提交成功')
      setactivatePhone('')
      setcardNum('')
      setSmsCode('')
    }else{
      setmessageDialogShow(res?.data?.msg ?? '提交失败')
    }
  }
  return (
    <div className='bw-100 d-flex-c jc-center ai-center' style={{ height: '100vh' }}>

      <img src="/pic/refundFeeHeader.jpg" alt="" className='bw-100 h-220' />
      <div className='bw-100 flex-1' style={{
        background: 'url(/pic/refundFeeCenter.jpg) no-repeat center center',
        backgroundSize: '100% 100%', // 按宽度100%缩放，高度自动
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      }}>
        <div className='d-flex-c ai-center jc-between bh-100 bw-100'>
          <div className='d-flex-c ai-center jc-center pl-30 pr-30'>
            <div className="d-flex-r ai-center jc-center font-size-16 pt-15 pb-15 pl-10 pr-10 bg-555 mt-20">
              <span>激活号码</span>
              <div className="flex-1 d-flex-c ai-end">
                <input
                  className="input text-right font-size-16 border-none bg-555"
                  type="text"
                  maxLength={11}
                  placeholder="请输入您的手机号码"
                  value={activatePhone}
                  onChange={(v) => setactivatePhone(v?.target?.value || '')}
                />
              </div>
            </div>
            <div className="d-flex-r ai-center jc-center font-size-16 pt-15 pb-15 pl-10 pr-10 bg-555 mt-15">
              <span>证件号码</span>
              <div className="flex-1 d-flex-c ai-end">
                <input
                  className="input  text-right font-size-16 border-none bg-555"
                  type="text"
                  maxLength={18}
                  placeholder="请输入您的身份证号"
                  value={cardNum}
                  onChange={(v) => setcardNum(v?.target?.value || '')}
                />
              </div>
            </div>
            <div className="d-flex-r ai-center jc-center font-size-16 pt-15 pb-15 pl-10 pr-10 bg-555 mt-15 ml-20 mr-20">
              <div className=" d-flex-c ai-end">
                <input
                  className="input w-160 font-size-16 border-none bg-555"
                  type="text"
                  maxLength={6}
                  placeholder="请输入短信验证码"
                  value={smsCode}
                  onChange={(v) => setSmsCode(v?.target?.value || '')}
                />
              </div>
              <div
                className="w-80 h-30 flex-1 font-size-16 border-radius-8 text-center text-color-white"
                style={{ background: smsCountdown > 0 ? '#999999' : '#e13a3e', lineHeight: '8vw', whiteSpace: 'nowrap', minWidth: '26vw' }}
                onClick={() => { if (smsCountdown <= 0) handleSendSmsCode() }}
              >
                {smsCountdown > 0 ? `${smsCountdown}s` : '获取验证码'}
              </div>
            </div>
          </div>
          
            <div className="btn w-120 bg-red mb-50 p-10 border-radius-8 text-center text-color-white" style={{background:'#e13a3e'}} onClick={handleSubmit}>
              立即领取
            </div>
          
        </div>

      </div>
      {/* <img src="/pic/refundFeeCenter.jpg" alt="" /> */}
      <img src="/pic/refundFeebottom.jpg" alt="" className='bw-100' />
      {captchaDialogShow && (
        <CaptchaDialog
          captchaImg={promptCode?.captchaImg}
          captchaCode={captchaCode}
          onChange={setcaptchaCode}
          onRefresh={getCodeImg}
          onConfirm={handleConfirmCaptcha}
          onClose={handleCloseCaptcha}
        />
      )}
      {!!messageDialogShow && (
              <MessageDialog title="系统提示" message={messageDialogShow} onClose={() => setmessageDialogShow('')} />
      )}
    </div>
  );
}
